/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiAlbumCollectionsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор выпуска")
    })

/**
 * @description Подборка удалена
 */
export const deleteApiAlbumCollectionsId200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiAlbumCollectionsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiAlbumCollectionsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiAlbumCollectionsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Подборка альбомов не найдена
 */
export const deleteApiAlbumCollectionsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiAlbumCollectionsId500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiAlbumCollectionsIdMutationResponseSchema = z.lazy(() => deleteApiAlbumCollectionsId200Schema)